import React from 'react';
import { Outlet } from "react-router-dom";
import VerticalNavbar from "../components/Reusable/Navbar/VerticalNavbar";
import Styles from "./Layout.module.css";

const Layout = () => {
  return (
    <div className={Styles.mainLayout}>
      {/* Vertical navbar */}
      <VerticalNavbar />

      {/* Main Content */}
      <main className={Styles.mainContentBox}>
        <div className={Styles.mainContent}>
          {/* Outlet renders the child route components */}
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
